import React from "react";
import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { BrowserRouter as Router } from "react-router-dom";

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  };

  const navItems = [
    { name: "home", label: "Home" },
    { name: "about", label: "About" },
    { name: "experience", label: "Experience" },
    { name: "skills", label: "Skills" },
    { name: "education", label: "Education" },
    { name: "projects", label: "Projects" },
    { name: "connect", label: "Contact" },
  ];

  return (
    <Router>
      <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
        <Container>
          <Navbar.Brand
            className={
              activeLink === "home" ? "active navbar-link" : "navbar-link"
            }
            href="#home"
            onClick={() => onUpdateActiveLink("home")}
          >
            <h1 style={{ display: "inline-block", color: "rgb(22 242 179" }}>
              Sachin Saurabh
            </h1>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav"></Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              {navItems.map((item) => (
                <Nav.Link
                  key={item.name}
                  href={`#${item.name}`}
                  className={
                    activeLink === item.name
                      ? "active navbar-link"
                      : "navbar-link"
                  }
                  onClick={() => onUpdateActiveLink(item.name)}
                >
                  {item.label}
                </Nav.Link>
              ))}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Router>
  );
};
